/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waiting_On_Document_ServiceInputs */

const en_waiting_on_document_service = /** @type {(inputs: Waiting_On_Document_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting on the Document Service`)
};

/**
* | output |
* | --- |
* | "Waiting on the Document Service" |
*
* @param {Waiting_On_Document_ServiceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const waiting_on_document_service = /** @type {((inputs?: Waiting_On_Document_ServiceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waiting_On_Document_ServiceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_waiting_on_document_service(inputs)
});